import { NFTIcon, SettingsIcon, WalletIcon } from "@tutellus/tutellus-components"

export const NAVIGATION_KEYS = {
  POAPS: "poaps",
  WALLET: "wallet",
  SETTINGS: "settings",
} as const

export type NavigationKey = (typeof NAVIGATION_KEYS)[keyof typeof NAVIGATION_KEYS]

export const NAVIGATION_ICONS = {
  [NAVIGATION_KEYS.POAPS]: <NFTIcon />,
  [NAVIGATION_KEYS.WALLET]: <WalletIcon />,
  [NAVIGATION_KEYS.SETTINGS]: <SettingsIcon />,
} as const

export const NAVIGATION_ROUTES = {
  [NAVIGATION_KEYS.POAPS]: "/",
  [NAVIGATION_KEYS.WALLET]: "/wallet",
} as const
